<div class="side-nav-container">
    <div class="smash-header-logo">
        <div (click)="redirectToLastSelectedTeam()">
            <i class="icon-smash_logo_no_chip"></i>
        </div>
    </div>
    <div class="side-nav-menu">
        <div class="side-nav-menu-box">
            <ng-container *ngFor="let teamSection of teamSections">
                <ng-container *ngIf="teamSection?.subsections?.length; else teamSubsections">
                    <div class="side-nav-menu-box-item" [ngClass]="{'side-nav-menu-box-item-active': teamSection.subMenuToggled }"
                        (click)="toggleTeamSubsections(teamSection)">
                        <div class="sort-icon" [ngClass]="{'sort-icon-activated-asc': !teamSection.subMenuToggled, 
                                        'sort-icon-activated-desc': teamSection.subMenuToggled}">
                            <i class="icon-smash_expand_arrow"></i>
                        </div>
                        <div class="parent-section-label">{{ teamSection.name ? teamSection.name : teamSection.team.id | translate }}</div>
                    </div>
                    <div class="side-nav-menu-box-items">
                        <ul class="side-nav-menu-box-sub-items-list" [@slideInOut]="teamSection.subMenuToggled ? 'in' : 'out'">
                            <ng-container *ngFor="let teamSubsection of teamSection.subsections">
                                <li class="side-nav-menu-box-sub-item" [routerLink]="teamSubsection.path"
                                    routerLinkActive="side-nav-menu-box-sub-item-active" [routerLinkActiveOptions]="{exact: false}">
                                    <div>{{ teamSubsection.title | translate }}</div>
                                </li>
                            </ng-container>
                        </ul>
                    </div>
                </ng-container>

                <ng-template #teamSubsections>
                    <div class="side-nav-menu-box-item" [routerLink]="teamSection.path" routerLinkActive="side-nav-menu-box-item-active"
                        [routerLinkActiveOptions]="{exact: false}">
                        {{ teamSection.title | translate }}
                    </div>
                </ng-template>
            </ng-container>

            <ng-container *ngFor="let adminSection of adminSections">
                <ng-container *ngIf="adminSection?.subsections?.length; else noAdminSubsections">
                    <div class="side-nav-menu-box-item" [ngClass]="{'side-nav-menu-box-item-active': adminSection.subMenuToggled }"
                        (click)="toggleAdminSubsections(adminSection)">
                        <div class="sort-icon" [ngClass]="{'sort-icon-activated-asc': !adminSection.subMenuToggled, 
                                        'sort-icon-activated-desc': adminSection.subMenuToggled}">
                            <i class="icon-smash_expand_arrow"></i>
                        </div>
                        <div class="parent-section-label">
                            {{ adminSection.name | translate }}
                        </div>
                    </div>
                    <div class="side-nav-menu-box-items">
                        <ul class="side-nav-menu-box-sub-items-list" [@slideInOut]="adminSection.subMenuToggled ? 'in' : 'out'">
                            <ng-container *ngFor="let adminSubsection of adminSection.subsections">
                                <li class="side-nav-menu-box-sub-item" [routerLink]="adminSubsection.path"
                                    routerLinkActive="side-nav-menu-box-sub-item-active" [routerLinkActiveOptions]="{exact: false}">
                                    <div>{{ adminSubsection.title | translate }}</div>
                                </li>
                            </ng-container>
                        </ul>
                    </div>
                </ng-container>

                <ng-template #noAdminSubsections>
                    <div class="side-nav-menu-box-item" [routerLink]="adminSection.path" routerLinkActive="side-nav-menu-box-item-active"
                        [routerLinkActiveOptions]="{exact: false}">
                        {{ adminSection.title | translate }}
                    </div>
                </ng-template>

            </ng-container>
        </div>
    </div>
    <div class="side-nav-footer-menu">
        <div class="side-nav-footer-menu-box">
            <a class="side-nav-footer-menu-outlook-container" href="{{'OUTLOOK_SECTION_LINK' | translate }}" target="_blank">
                <img class="side-nav-footer-menu-icon" src="assets/img/outlook.png">
                <div class="side-nav-footer-menu-label">{{ 'OUTLOOK_SECTION_LABEL' | translate }}</div>
            </a>
            <a class="side-nav-footer-menu-outlook-container" href="{{'HELP_SECTION_LINK' | translate }}" target="_blank">
                <img class="side-nav-footer-menu-icon" src="assets/img/FAQ.png">
                <div class="side-nav-footer-menu-label">{{ 'HELP_SECTION' | translate }}</div>
            </a>
            <div class="version">{{'VERSION' | translate }} : {{version}}</div>
        </div>
    </div>
</div>